import {
  PAGE_ADM_DRAFTS,
  PAGE_ADM_EDIT_REPORT,
  PAGE_ADM_EXPORTS,
  PAGE_ADM_NEW_REPORT,
  PAGE_ADM_REPORT,
  PAGE_ADM_REPORTS
} from "../../pages/Adm/routes";
import {
  PAGE_DOM_APPROVERS,
  PAGE_DOM_DASHBOARD,
  PAGE_DOM_DOCUMENT,
  PAGE_DOM_DOCUMENTS,
  PAGE_DOM_DOCUMENTS_MASS_DUPLICATION,
  PAGE_DOM_EDIT_APPROVER,
  PAGE_DOM_EDIT_HISTORY_TEMPLATE,
  PAGE_DOM_EDIT_RESPONSIBLE_PERSON,
  PAGE_DOM_ENTITIES,
  PAGE_DOM_HISTORY_DOCUMENT,
  PAGE_DOM_NEW_APPROVER,
  PAGE_DOM_NEW_RESPONSIBLE_PERSON,
  PAGE_DOM_RESPONSIBLE_PERSONS,
  PAGE_DOM_TEMPLATES,
  PAGE_DOM_VIEW_TEMPLATE_HISTORY
} from "../../pages/Dom/routes";
import {
  PAGE_RSM_DASHBOARD,
  PAGE_RSM_EDIT_PUBLICATION,
  PAGE_RSM_MY_PUBLICATIONS,
  PAGE_RSM_NEW_PUBLICATION,
  PAGE_RSM_PUBLICATIONS,
  PAGE_RSM_REPORTING,
  PAGE_RSM_VIEW_MY_PUBLICATION,
  PAGE_RSM_VIEW_PUBLICATION
} from "../../pages/Rsm/routes";
import {
  PAGE_TRG_DASHBOARD,
  PAGE_TRG_EDIT_PLANNING,
  PAGE_TRG_EXTERNAL_PROVIDERS,
  PAGE_TRG_MASS_ASSIGNMENT,
  PAGE_TRG_NEW_PLANNING,
  PAGE_TRG_PLANNING,
  PAGE_TRG_PLANNING_CALENDAR,
  PAGE_TRG_QUALIFICATIONS,
  PAGE_TRG_REPORTING,
  PAGE_TRG_TRAINING_MATRIX,
  PAGE_TRG_TRAINING_PROGRAM,
  PAGE_TRG_TRAININGS,
  PAGE_TRG_VIEW_PLANNING
} from "../../pages/Trg/routes";
import {
  PERMISSION_MANAGE_ADM,
  PERMISSION_MANAGE_RSM_PUBLICATIONS,
  PERMISSION_VIEW_ADM,
  PERMISSION_VIEW_DOM_APPROVERS,
  PERMISSION_VIEW_DOM_DASHBOARD,
  PERMISSION_VIEW_DOM_DOCUMENTS,
  PERMISSION_VIEW_DOM_ENTITIES,
  PERMISSION_VIEW_DOM_RESPONSIBLE_PERSONS,
  PERMISSION_VIEW_DOM_TEMPLATES,
  PERMISSION_VIEW_RSM_PUBLICATIONS,
  PERMISSION_VIEW_RSM_REPORTING,
  PERMISSION_VIEW_TRG,
  PERMISSION_VIEW_TRG_PLANNING
} from "./permissions/permissions";

/** Regulatory/Safety Management — publications, distribution and regulatory reporting. */
export const NAV_RSM = {
  key: "rsm",
  name: "container.sidebar.rsm",
  iconClassName: "ti-write",
  gates: [PERMISSION_MANAGE_RSM_PUBLICATIONS, PERMISSION_VIEW_RSM_PUBLICATIONS, PERMISSION_VIEW_RSM_REPORTING],
  submenu: [
    {
      key: "rsm.rsm_dashboard",
      name: "container.sidebar.dashboard",
      path: PAGE_RSM_DASHBOARD,
      gates: PERMISSION_VIEW_RSM_PUBLICATIONS
    },
    {
      key: "rsm.rsm_publications",
      name: "container.sidebar.rsm_publications",
      path: PAGE_RSM_PUBLICATIONS,
      gates: PERMISSION_MANAGE_RSM_PUBLICATIONS,
      activeRoutes: [PAGE_RSM_NEW_PUBLICATION, PAGE_RSM_EDIT_PUBLICATION, PAGE_RSM_VIEW_PUBLICATION]
    },
    {
      key: "rsm.rsm_my_publications",
      name: "container.sidebar.rsm_my_publications",
      path: PAGE_RSM_MY_PUBLICATIONS,
      gates: PERMISSION_VIEW_RSM_PUBLICATIONS,
      activeRoutes: [PAGE_RSM_VIEW_MY_PUBLICATION]
    },
    {
      key: "rsm.reporting",
      name: "container.sidebar.reporting",
      path: PAGE_RSM_REPORTING,
      gates: PERMISSION_VIEW_RSM_REPORTING
    }
  ]
};

/** Document Management — documents, templates, approvers, responsible persons, entities. */
export const NAV_DOM = {
  key: "dom",
  name: "container.sidebar.dom",
  iconClassName: "ti-folder",
  gates: [
    PERMISSION_VIEW_DOM_DASHBOARD,
    PERMISSION_VIEW_DOM_DOCUMENTS,
    PERMISSION_VIEW_DOM_ENTITIES,
    PERMISSION_VIEW_DOM_RESPONSIBLE_PERSONS,
    PERMISSION_VIEW_DOM_APPROVERS,
    PERMISSION_VIEW_DOM_TEMPLATES
  ],
  submenu: [
    {
      key: "dom.dashboard",
      name: "container.sidebar.dashboard",
      path: PAGE_DOM_DASHBOARD,
      gates: PERMISSION_VIEW_DOM_DASHBOARD
    },
    {
      key: "dom.documents",
      name: "container.sidebar.documents",
      path: PAGE_DOM_DOCUMENTS,
      activeRoutes: [PAGE_DOM_DOCUMENT, PAGE_DOM_HISTORY_DOCUMENT, PAGE_DOM_DOCUMENTS_MASS_DUPLICATION],
      gates: PERMISSION_VIEW_DOM_DOCUMENTS
    },
    {
      key: "dom.entities",
      name: "container.sidebar.entities",
      path: PAGE_DOM_ENTITIES,
      gates: PERMISSION_VIEW_DOM_ENTITIES
    },
    {
      key: "dom.approvers",
      name: "container.sidebar.approvers",
      path: PAGE_DOM_APPROVERS,
      activeRoutes: [PAGE_DOM_EDIT_APPROVER, PAGE_DOM_NEW_APPROVER],
      gates: PERMISSION_VIEW_DOM_APPROVERS
    },
    {
      key: "dom.responsible_persons",
      name: "container.sidebar.responsible_persons",
      path: PAGE_DOM_RESPONSIBLE_PERSONS,
      activeRoutes: [PAGE_DOM_EDIT_RESPONSIBLE_PERSON, PAGE_DOM_NEW_RESPONSIBLE_PERSON],
      gates: PERMISSION_VIEW_DOM_RESPONSIBLE_PERSONS
    },
    {
      key: "dom.templates",
      name: "container.sidebar.templates",
      path: PAGE_DOM_TEMPLATES,
      activeRoutes: [PAGE_DOM_VIEW_TEMPLATE_HISTORY, PAGE_DOM_EDIT_HISTORY_TEMPLATE],
      gates: PERMISSION_VIEW_DOM_TEMPLATES
    }
  ]
};

/** Training Management — trainings, matrix, program, planning, qualifications, reporting. */
export const NAV_TRG = {
  key: "trg",
  name: "container.sidebar.trg",
  iconClassName: "ti-medall-alt",
  gates: [PERMISSION_VIEW_TRG_PLANNING, PERMISSION_VIEW_TRG],
  submenu: [
    {
      key: "trg.trg_dashboard",
      name: "container.sidebar.trg_dashboard",
      path: PAGE_TRG_DASHBOARD,
      gates: PERMISSION_VIEW_TRG
    },
    {
      key: "trg.trainings",
      name: "container.sidebar.trainings",
      path: PAGE_TRG_TRAININGS,
      gates: PERMISSION_VIEW_TRG
    },
    {
      key: "trg.training_matrix",
      name: "container.sidebar.training_matrix",
      path: PAGE_TRG_TRAINING_MATRIX,
      gates: PERMISSION_VIEW_TRG
    },
    {
      key: "trg.training_program",
      name: "container.sidebar.training_program",
      path: PAGE_TRG_TRAINING_PROGRAM,
      gates: PERMISSION_VIEW_TRG
    },
    {
      key: "trg.planning",
      name: "container.sidebar.planning",
      path: PAGE_TRG_PLANNING,
      gates: PERMISSION_VIEW_TRG_PLANNING,
      activeRoutes: [PAGE_TRG_NEW_PLANNING, PAGE_TRG_EDIT_PLANNING, PAGE_TRG_VIEW_PLANNING, PAGE_TRG_PLANNING_CALENDAR]
    },
    {
      key: "trg.qualifications",
      name: "container.sidebar.qualifications",
      path: PAGE_TRG_QUALIFICATIONS,
      gates: PERMISSION_VIEW_TRG,
      activeRoutes: [PAGE_TRG_MASS_ASSIGNMENT]
    },
    {
      key: "trg.reporting",
      name: "container.sidebar.reporting",
      path: PAGE_TRG_REPORTING,
      gates: PERMISSION_VIEW_TRG
    },
    {
      key: "trg.external_providers",
      name: "container.sidebar.external_providers",
      path: PAGE_TRG_EXTERNAL_PROVIDERS,
      gates: PERMISSION_VIEW_TRG
    }
  ]
};

/** Administrative Reports — custom report builder, drafts, and export queue. */
export const NAV_ADM = {
  key: "adm",
  name: "container.sidebar.adm",
  iconClassName: "ti-server",
  gates: [PERMISSION_VIEW_ADM, PERMISSION_MANAGE_ADM],
  submenu: [
    {
      key: "adm.adm_reports",
      name: "container.sidebar.adm_reports",
      path: PAGE_ADM_REPORTS,
      gates: PERMISSION_VIEW_ADM,
      activeRoutes: [PAGE_ADM_NEW_REPORT, PAGE_ADM_EDIT_REPORT, PAGE_ADM_REPORT]
    },
    {
      key: "adm.adm_drafts",
      name: "container.sidebar.adm_drafts",
      path: PAGE_ADM_DRAFTS,
      gates: PERMISSION_MANAGE_ADM
    },
    {
      key: "adm.adm_exports_in_queue",
      name: "container.sidebar.adm_exports_in_queue",
      path: PAGE_ADM_EXPORTS,
      gates: PERMISSION_VIEW_ADM
    }
  ]
};
